<app-cards-basic title="Prices" [loading]="isLoading">
  @defer {
    <app-table-basic [dataSource]="priceListData"
                     [columnDef]="columnDef"
                     (selectionChange)="onSelectionChange($event)"
                     (pageChange)="onPageChange($event)">
    </app-table-basic>

    @if (isFormVisible) {

      <form #priceForm="ngForm" (ngSubmit)="savePrice()" class="pt-3">

        <div class="row">
          <mat-form-field appearance="fill" class="col">
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="startDatePicker"
                   required
                   [(ngModel)]="price.date"
                   name="Date"
                   #date="ngModel">
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
            <mat-error *ngIf="date.invalid && date.touched">
              Date is required.
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col">
            <mat-label>Closing Price</mat-label>
            <input matInput
                   required
                   [(ngModel)]="price.close"
                   name="ClosePrice"
                   #closePrice="ngModel">
            <mat-error *ngIf="closePrice.invalid && closePrice.touched">
              Closing Price is required.
            </mat-error>
          </mat-form-field>

        </div>

        <button mat-button color="primary" (click)="toggleFormVisibility()" type="button" class="bp-button">Cancel
        </button>
        <button mat-button color="primary" [disabled]="!priceForm.valid" type="submit" class="bp-button">Save
          Price
        </button>
      </form>

    } @else {
      <button mat-flat-button
              color="primary"
              (click)="toggleFormVisibility()"
              class="mt-3 bp-button">
        Add Price
      </button>
      <button mat-flat-button
              color="primary"
              (click)="fileInput.click()"
              class="mt-3 bp-button"
              style="margin-left: 6px">
        Import CSV
      </button>
      <input type="file" #fileInput (change)="importCSV($event)" style="display:none">
      @if (priceListData.count > 0) {
        @if(selectedRows.length === 0){
          <button mat-flat-button
                  color="primary"
                  (click)="deleteAllPrices()"
                  class="mt-3 bp-button"
                  style="margin-left: 6px">
            Delete all {{ priceListData.count }} prices
          </button>
        }
        <button mat-flat-button
                color="primary"
                (click)="deleteSelectedItems()"
                class="mt-3 bp-button"
                style="margin-left: 6px">
          Delete {{ selectedRows.length }} items
        </button>

      }

    }

  }
</app-cards-basic>
